export default __webpack_public_path__ + "static/helix-bq-2-0062b4bcab2f868cf17b2a57d5cc071b.jpg";